import React, { useEffect, useState } from 'react';
import { SystemCheck, SystemCheckResult } from '../utils/SystemCheck';
import { 
  Box, 
  Typography, 
  CircularProgress, 
  Alert, 
  List, 
  ListItem, 
  ListItemText 
} from '@mui/material';

export const SystemHealthCheck: React.FC = () => {
  const [checking, setChecking] = useState(true);
  const [results, setResults] = useState<SystemCheckResult | null>(null);

  useEffect(() => {
    const runCheck = async () => {
      try {
        console.log('Starting system health check...');
        const systemCheck = SystemCheck.getInstance();
        const checkResults = await systemCheck.runFullCheck();
        console.log('Health check results:', checkResults);
        setResults(checkResults);
      } catch (error) {
        console.error('Health check error:', error);
        setResults({
          success: false,
          details: {
            environment: { 
              success: true, 
              missingVars: [],
              message: 'All environment variables are set' 
            },
            api: { 
              success: false, 
              endpoints: { health: false },
              message: error instanceof Error ? error.message : 'Unknown error' 
            },
            s3: { 
              success: true, 
              bucketAccess: true,
              uploadTest: false,
              message: 'S3 check completed successfully' 
            },
            database: { 
              success: true, 
              tables: {},
              message: 'Database check completed' 
            }
          },
          timestamp: new Date()
        });
      } finally {
        setChecking(false);
      }
    };

    runCheck();
  }, []);

  if (checking) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!results) {
    return <Alert severity="error">Failed to run system checks</Alert>;
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        System Health Status
      </Typography>
      
      <Alert severity={results.success ? "success" : "error"}>
        System Status: {results.success ? "Healthy" : "Issues Detected"}
      </Alert>

      <List>
        {Object.entries(results.details).map(([category, check]) => (
          <ListItem key={category}>
            <ListItemText
              primary={
                <Box display="flex" alignItems="center" gap={1}>
                  {category}: {check.success ? '✅' : '❌'}
                </Box>
              }
              secondary={check.message}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}; 